import React from "react";
import {Link, useLocation} from "react-router-dom";

export const AnalyticsWrapper = ({children}) => {
  const location = useLocation();

  return (
    <>
      <div className="top-balance">
        <h1 className="top-balance__title">Analytics</h1>
      </div>
      <div className="tab-header">
        <Link
          className={`tab-header__btn ${
            location.pathname === "/analytics" ? "active" : ""
          }`}
          to="/analytics"
        >
          Date
        </Link>
        <Link
          className={`tab-header__btn ${
            location.pathname === "/analytics/users" ? "active" : ""
          }`}
          to="/analytics/users"
        >
          Users
        </Link>
        
      </div>
      <div className="tab-content tab-content--scroll">
        {children}
      </div>
    </>
  );
};
